var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("ul", { staticClass: "nav nav-pills" }, [
      _c(
        "li",
        {
          staticClass: "nav-item",
          class: { active2: _vm.ActivePage === "criteria-hierarchy" },
        },
        [
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: _vm.url_CriteriaPage,
                  expression: "url_CriteriaPage",
                },
              ],
              staticClass: "nav-link",
            },
            [_vm._v("\n                Criteria\n            ")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "nav-item",
          class: { active2: _vm.ActivePage === "measurement" },
        },
        [
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: _vm.url_MeasurementsPage,
                  expression: "url_MeasurementsPage",
                },
              ],
              staticClass: "nav-link",
            },
            [_vm._v("\n                Measurement\n            ")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "nav-item",
          class: { active2: _vm.ActivePage === "criteria-surveys" },
        },
        [
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: _vm.url_WeightsPage,
                  expression: "url_WeightsPage",
                },
              ],
              staticClass: "nav-link",
            },
            [_vm._v("\n                Weights\n            ")]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.ScoringEnabled
        ? _c(
            "li",
            {
              staticClass: "nav-item",
              class: { active2: _vm.ActivePage === "scoring-surveys" },
            },
            [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "sanitizedHref",
                      rawName: "v-sanitizedHref",
                      value: _vm.url_ScoringPanelsPage,
                      expression: "url_ScoringPanelsPage",
                    },
                  ],
                  staticClass: "nav-link",
                },
                [_vm._v("\n                Scoring\n            ")]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.ScoringEnabled
        ? _c(
            "li",
            {
              staticClass: "nav-item",
              class: { active2: _vm.ActivePage === "weighted-scores" },
            },
            [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "sanitizedHref",
                      rawName: "v-sanitizedHref",
                      value: _vm.url_WeightedScoresPage,
                      expression: "url_WeightedScoresPage",
                    },
                  ],
                  staticClass: "nav-link",
                },
                [_vm._v("\n                Scores\n            ")]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "nav-item",
          class: { active2: _vm.ActivePage === "results" },
        },
        [
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: _vm.url_RankingPage,
                  expression: "url_RankingPage",
                },
              ],
              staticClass: "nav-link",
            },
            [_vm._v("\n                Ranking\n            ")]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("hr", { staticStyle: { "border-color": "#bbb", margin: "0 0 60px" } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }